import { useState } from 'react';
import { Spin, Alert } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as claus from 'src/_shared/services/claus/endpoints';
import Section from '../../console/Section.jsx';
import { useAsync } from '../hooks/useClaus';
import SftpCredentialsDialog from '../dialogs/SftpCredentialsDialog.jsx';

// SFTP credentials for the org (shared across SFTP integrations). Creating one returns a one-time
// secret shown in the dialog. The add action sits on the section-title row per the design.
export default function SftpCredentialsSection({ orgId }) {
	const { loading, data, error, reload } = useAsync(() => claus.listSftpCredentials(orgId), [orgId]);
	const [creating, setCreating] = useState(false);

	const items = Array.isArray(data) ? data : data?.items || [];

	return (
		<Section
			id="sec-sftp"
			title="SFTP credentials"
			description="Shared credentials ERIN uses to read files from the SFTP drop."
			actions={
				<button type="button" className="js-btn" onClick={() => setCreating(true)}>
					<PlusOutlined /> Add SFTP credential
				</button>
			}
		>
			{error && <Alert type="error" showIcon message="Could not load SFTP credentials" description={error.message} />}

			{loading ? (
				<div className="js-loading js-loading--inline">
					<Spin />
				</div>
			) : items.length === 0 ? (
				<div className="ei-empty-inline">No SFTP credentials.</div>
			) : (
				<div>
					{items.map((c) => (
						<div className="ei-hookrow" key={c.id}>
							<div className="ei-hookmain">
								<div className="ei-hookname">{c.name}</div>
								<div className="ei-hookurl">
									{c.username} · {c.authType === 'sftp_ssh' ? 'SSH key' : 'password'}
								</div>
							</div>
						</div>
					))}
				</div>
			)}

			<SftpCredentialsDialog
				orgId={orgId}
				open={creating}
				onClose={() => setCreating(false)}
				onCreated={async () => {
					setCreating(false);
					await reload();
				}}
			/>
		</Section>
	);
}
